import React from "react";
import "./EventStatusModal.css";

const EventStatusModal = ({ isOpen, onClose, status, onEdit }) => {
  if (!isOpen) return null;

  const getModalContent = () => {
    switch (status) {
      case "pending":
        return {
          icon: (
            <svg
              width="60"
              height="60"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"
                fill="#ff9800"
              />
            </svg>
          ),
          title: "Event Under Review",
          message:
            "Your event is currently being reviewed by our admin team. You'll receive an email notification once it's approved and ready to share.",
          buttonText: "Got It",
          buttonClass: "event-status-modal-ok-btn",
        };
      case "declined":
      case "rejected":
        return {
          icon: (
            <svg
              width="60"
              height="60"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"
                fill="#d32f2f"
              />
            </svg>
          ),
          title: "Event Declined",
          message:
            "Your event was declined. Please check your email for admin feedback.",
          buttonText: "Edit Event",
          buttonClass: "event-status-modal-edit-btn",
          showCancel: true,
        };
      default:
        return null;
    }
  };

  const content = getModalContent();
  if (!content) return null;

  const handleAction = () => {
    if (status === "declined" || status === "rejected") {
      if (onEdit) {
        onEdit();
      }
    }
    onClose();
  };

  return (
    <div className="event-status-modal-overlay" onClick={onClose}>
      <div
        className="event-status-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="event-status-modal-icon">{content.icon}</div>

        <h2 className="event-status-modal-title">{content.title}</h2>

        <p className="event-status-modal-message">{content.message}</p>

        <div className="event-status-modal-actions">
          {content.showCancel && (
            <button onClick={onClose} className="event-status-modal-cancel-btn">
              Cancel
            </button>
          )}
          <button onClick={handleAction} className={content.buttonClass}>
            {content.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventStatusModal;